import React, { FC } from 'react';
import {make_board, set_pieces, set_control_piece} from './game';
import {Setting} from "./setting";
import useReactRouter from 'use-react-router';
import { firebase_auth } from './config/firebase';
import Alert from './material/alert'
import { GameLive } from "./gameLive";

export const Live: FC = () => {
  const [enter_kifu_invalid, setEnterKifuInvalid] = React.useState(false);

  const handleEnterKifuClose = () => {
    setEnterKifuInvalid(false);
  }

  const {location} = useReactRouter();
  const paths = location.pathname.split("/");
  const room_id = paths[2];
  let is_black = true;

  firebase_auth.signInAnonymously().catch(function() {
    // Handle Errors here.
  });

  const ua = navigator.userAgent.toLowerCase();
  const is_mobile = (ua.match(/Mobile/) !== null) || (ua.match(/mobile/) !== null);

  return(
    <div>
      <GameLive
        start_pos={make_board()}
        start_black_piece={set_pieces()}
        start_white_piece={set_pieces()}
        current_pos={make_board()}
        current_black_piece={set_pieces()}
        current_white_piece={set_pieces()}
        control_piece={set_control_piece()}
        control_piece_sub={set_control_piece()}
        turn={true}
        clicked_piece={Setting.UNCLICKED}
        final_piece={Setting.UNCLICKED}
        is_black={is_black}
        is_black_sub={is_black}
        inversion_moves={0}
        moved_piece={Setting.UNCLICKED}
        promotion={false}
        is_mobile={is_mobile}
        room_id={room_id}
      />
      <Alert
        title={"棋譜が存在しません。"}
        message={""}
        open={enter_kifu_invalid}
        handleClose={handleEnterKifuClose}
      />
    </div>
  );
}
